export default __webpack_public_path__ + "static/media/menuToggler.4bcbe06d.svg";